module.exports = __webpack_public_path__ + "img/E2 UB4.e61c0888.png";